export default __webpack_public_path__ + "static/media/sales1024.7a89c34d.png";